import React from 'react';
import '../../styles/components/warning-box.scss';
import { AlertTriangle } from 'lucide-react';

export class WarningBox extends React.Component {
  handleApprove = () => {
    if (this.props.onAppove) {
      this.props.onAppove();
    }
  };

  handleReject = () => {
    if (this.props.onReject) {
      this.props.onReject();
    }
  };

  render() {
    return (
      <div className="warning-box">
        <div className="warning-content">
          <div className="warning-icon">
            <AlertTriangle size={22} color="#856404" />
          </div>
          <div className="warning-message">
            Refund Warning . Please review carefully before proceeding.
          </div>
          <div className="warning-buttons">
            <button className="btn-approve" onClick={() => this.handleApprove()}>
              Approve
            </button>
            <button className="btn-reject" onClick={() => this.handleReject()}>
              Reject
            </button>
          </div>
        </div>
      </div>
    );
  }
}
